import { memo } from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import UILink from 'UIComponents/link/UILink';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { trackInsightsInteraction } from '../../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function Reason({
  reason
}) {
  switch (reason.insightReasonType) {
    case 'SUBJECT_LINE_TOO_LONG':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.SUBJECT_LINE_TOO_LONG"
        });
      }
    case 'SUBJECT_LINE_TOO_MANY_EMOJI':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.SUBJECT_LINE_TOO_MANY_EMOJI"
        });
      }
    //@ts-expect-error waiting for BE to implement, then we regenerate client types
    case 'SUBJECT_LINE_WITHOUT_PERSONALISATION':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.SUBJECT_LINE_WITHOUT_PERSONALISATION"
        });
      }
    //@ts-expect-error waiting for BE to implement, then we regenerate client types
    case 'SUBJECT_LINE_WITH_EMOJI':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.SUBJECT_LINE_WITH_EMOJI"
        });
      }
    case 'SENT_TO_LOW_PERFORMING_CONTACT_LIST':
      {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "messaging-insights.insights.reasons.SENT_TO_LOW_PERFORMING_CONTACT_LIST"
          }), /*#__PURE__*/_jsx(UIList, {
            styled: true,
            children: reason.metadata.lowPerformingContactListEntityInfo.map(({
              entityId,
              name
            }) => {
              const href = `/contacts/${PortalIdParser.get()}/objectLists/${entityId}`;
              return /*#__PURE__*/_jsx(UILink, {
                external: true,
                href: href,
                onClick: () => void trackInsightsInteraction({
                  action: 'click-contacts-link'
                }),
                children: name
              }, entityId);
            })
          })]
        });
      }
    case 'CAMPAIGN_SEND_VOLUME_SPIKE':
      {
        const value = reason.metadata.percentageDifference;
        return /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "messaging-insights.insights.reasons.CAMPAIGN_SEND_VOLUME_SPIKE",
          options: {
            difference: /*#__PURE__*/_jsx(FormattedPercentage, {
              value: value,
              precision: 1
            })
          }
        });
      }
    case 'PREVIEW_TEXT_MISSING':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.PREVIEW_TEXT_MISSING"
        });
      }
    case 'EMAIL_GRAYMAIL_DISABLED':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.EMAIL_GRAYMAIL_DISABLED"
        });
      }
    case 'EMAIL_CLIPPED':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.EMAIL_CLIPPED"
        });
      }
    case 'MISSING_SENDER_PERSONALISATION':
      {
        const {
          missingPersonalisedFromName,
          missingPersonalisedFromAddress
        } = reason.metadata;
        if (missingPersonalisedFromName && missingPersonalisedFromAddress) return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.MISSING_SENDER_PERSONALISATION.both"
        });
        if (missingPersonalisedFromAddress) return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.MISSING_SENDER_PERSONALISATION.onlyFromAddress"
        });
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.MISSING_SENDER_PERSONALISATION.onlySenderName"
        });
      }
    case 'CONTENT_POOR_CTA':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.CONTENT_POOR_CTA"
        });
      }
    case 'EMAIL_CONTENT_MISSING_PERSONALISATION':
      {
        return reason.metadata.portalsTopEmailsUsePersonalisation ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.EMAIL_CONTENT_MISSING_PERSONALISATION.portalsTopEmailsUsePersonalisation"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.EMAIL_CONTENT_MISSING_PERSONALISATION.default"
        });
      }
    case 'TOO_MANY_IMAGES_WITHOUT_LINKS':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.TOO_MANY_IMAGES_WITHOUT_LINKS",
          options: {
            maximumIdealNumberOfImagesWithoutLinks: reason.metadata.maximumIdealNumberOfImagesWithoutLinks
          }
        });
      }
    case 'TOO_MANY_IMAGES':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.TOO_MANY_IMAGES"
        });
      }
    case 'TOO_MANY_LINKS':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.TOO_MANY_LINKS"
        });
      }
    case 'CONTENT_CTA_TOO_LONG':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.reasons.CONTENT_CTA_TOO_LONG"
        });
      }
    default:
      {
        return null;
      }
  }
}
function Reasons({
  reasons,
  sentiment
}) {
  if (!(reasons !== null && reasons !== void 0 && reasons.length)) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: `messaging-insights.insights.reasons.empty.${sentiment}`
    });
  }
  const reasonListItems = reasons.flatMap(reason => Reason({
    reason
  }));
  if (reasonListItems.length === 1) return reasonListItems;
  return /*#__PURE__*/_jsx(UIList, {
    styled: true,
    children: reasonListItems
  });
}
export default /*#__PURE__*/memo(Reasons);